import { IPOMASTERBANK_DATA, IPOMASTERBANK_ERROR_DATA, IPOMASTERBANK_HIDE_ERROR_DATA, IPOMASTERBANK_START_LOADER, IPOMASTERBANK_STOP_LOADER, } from "../interface/IpoBankMaster";
const initState = {
    IpoMasterBank: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const IpoMasterBank = (state = initState, action) => {
    switch (action.type) {
        case IPOMASTERBANK_DATA:
            return Object.assign(Object.assign({}, state), { IpoMasterBank: action.payload.data });
        case IPOMASTERBANK_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case IPOMASTERBANK_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case IPOMASTERBANK_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case IPOMASTERBANK_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default IpoMasterBank;
